<template>
  <div class="data-export-result">
    <template v-if="optimizeTask">
      <div class="export-task-body">
        <AppScrollbar style="height: 100%">
          <div class="export-wrap">
            <div class="items">
              <template v-if="stateInfo && stateInfo.items">
                <a v-for="item in stateInfo.items"
                   :key="item.itemIndex"
                   :href="$contextPath(item.fileLink)"
                   target="_blank"
                   class="item">
                  <div class="label">
                    <i class="el-icon-document"></i>
                    <span>{{item.fileName}}</span>
                  </div>
                  <div class="extra">
                    <i class="el-icon-download"></i>
                    <span>下载</span>
                  </div>
                </a>
              </template>
            </div>
            <div v-if="loading"
                 class="state">
              <i class="el-icon-loading"></i>
              <span>文件导出中...</span>
              <span v-if="stateInfo && stateInfo.percentage">({{stateInfo.percentage}}%)</span>
            </div>
          </div>
        </AppScrollbar>
      </div>
    </template>
    <template v-else>
      <div class="export-result-body">
        <div class="tip-message">
          <i class="iconfont icon-correct-bold"></i>
          <span>数据文件导出生成成功</span>
        </div>
        <div class="download-link">
          <a class="el-button el-button--success el-button--mini"
             :href="$contextPath(downloadLink)"
             target="_blank">
            <i class="iconfont icon-cloud-down"></i>
            <span>点击下载文件（{{fileName}}）</span>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import baseApiUrl from '../../../../constants/baseApiUrl'
import routeConfig from '../../../../constants/routeConfig'
import AppScrollbar from '../../AppScrollbar'
export default {
  name: 'DataExportResult',
  components: {
    AppScrollbar
  },
  props: {
    optimizeTask: Boolean,
    fileName: String,
    downloadLink: String
  },
  data () {
    return {
      loading: false,
      stateInfo: null
    }
  },
  methods: {
    loadExportState () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.loading = true
      let params = this.$extend({
        requestType: 'exportState'
      }, postParams)
      this.$ajax({
        url: baseApiUrl.DataGridUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.stateInfo = response.data['stateInfo'] || {}
              if (response.data['complete']) {
                this.$message.success(response.data['message'] || '导出任务执行结束')
                this.loading = false
              } else {
                this.timer = setTimeout(this.loadExportState, 1000)
              }
              break
            }
            default: {
              this.$message.warning(response.data['message'] || '导出状态获取失败')
              this.loading = false
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍候重试')
        this.timer = setTimeout(this.loadExportState, 1000)
      })
    }
  },
  mounted () {
    if (this.optimizeTask) {
      this.loadExportState()
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style lang="scss">
  @use "../../../../styles/color" as *;
  .data-export-result {
    height: 100%;
    &>.export-task-body {
      height: 100%;
      background-color: #fff;
      .export-wrap {
        padding: 5px 15px;
        &>.items {
          &>.item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: $set-success-color;
            font-size: 13px;
            padding: 12px 15px;
            text-decoration: none;
            &:active {
              background-color: rgba(0,0,0,.03);
            }
            &>.extra {
              margin-left: 10px;
            }
            i {
              margin-right: 4px;
              font-size: 14px;
              vertical-align: -1px;
            }
            &+.item {
              border-top: 1px solid #ebeef5;
            }
          }
        }
        &>.state {
          text-align: center;
          font-size: 13px;
          padding: 10px 15px;
        }
      }
    }
    &>.export-result-body {
      padding-top: 120px;
      .tip-message {
        text-align: center;
        color: $set-primary-color;
        font-size: 13px;
        span {
          vertical-align: 1px;
        }
      }
      .download-link {
        margin-top: 20px;
        text-align: center;
        a {
          font-size: 13px;
          text-decoration: none;
          span {
            vertical-align: 1px;
          }
        }
      }
    }
  }
</style>
